/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import Pagination from "components/Pagination/Pagination.js";
import AccordionSummary from "@material-ui/core/AccordionSummary"
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import TextField from '@material-ui/core/TextField';

// @material-ui/core icons
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import Remove from "@material-ui/icons/Remove";
import Add from "@material-ui/icons/Add";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import Reply from "@material-ui/icons/Reply";
import Favorite from "@material-ui/icons/Favorite";
import SearchBar from "material-ui-search-bar";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { FcCheckmark } from "react-icons/fc";
import OrderHistoryTable from '../Sections/OrderHistoryTable.js';

// style css
import recentOrdersStyle from "assets/jss/CustomerTradePortal/views/LandingPageSections/recentOrderStyle.js";
const useStyles = makeStyles(recentOrdersStyle);

export default function RecentOrders() {
    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    });

    const classes = useStyles();


    const fillButtons = [
        { color: "info", icon: Person },
        { color: "success", icon: Edit },
        { color: "danger", icon: Close },
    ].map((prop, key) => {
        return (
            <Button justIcon size="sm" color={prop.color} key={key}>
                <prop.icon />
            </Button>
        );
    });
    const simpleButtons = [
        { color: "info", icon: Person },
        { color: "success", icon: Edit },
        { color: "danger", icon: Close },
    ].map((prop, key) => {
        return (
            <Button simple justIcon size="sm" color={prop.color} key={key}>
                <prop.icon />
            </Button>
        );
    });
    const roundButtons = [
        { color: "info", icon: Person },
        { color: "success", icon: Edit },
        { color: "danger", icon: Close },
    ].map((prop, key) => {
        return (
            <Button round justIcon size="sm" color={prop.color} key={key}>
                <prop.icon />
            </Button>
        );
    });

    const downloadButton = [
        { color: "danger", icon: PictureAsPdfIcon },
    ].map((prop, key) => {
        return (
            <Button round justIcon size="sm" color={prop.color} key={key}>
                <prop.icon />
            </Button>
        );
    });

    const input = [
        { color: "danger", icon: PictureAsPdfIcon },
    ].map((prop, key) => {
        return (
            <TextField
                id="outlined-full-width"
                label="Packs"
                placeholder="Packs"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                    shrink: true
                }}
            />
        );
    });


    let pagination;

    pagination = <div>
        <Pagination
            pages={[
                { disabled: true, text: "Previous" },
                { text: 1 },
                { active: true, text: 2 },
                { text: 3 },
                { text: "Next" }
            ]}
        />
    </div>

    let isPaidBool;
    isPaidBool = <FcCheckmark size={30} > </FcCheckmark>

    let isDespactedBool;
    isDespactedBool = <FcCheckmark size={30} > </FcCheckmark>


    return (
        <div>
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.contactContent}>
                    <div className={classes.container}>

                        <GridContainer>
                            <GridItem md={12} sm={12}>
                                <h2 className={classes.title}>Recent Orders</h2>
                                <Accordion defaultExpanded={true}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"

                                    >
                                        <h5 className={classes.title}>View Your Order History</h5>
                                    </AccordionSummary>
                                    <div style={{ padding: "14px" }}>

                                        <OrderHistoryTable />

                                    </div>
                                </Accordion>
                            </GridItem>

                        </GridContainer>
                    </div>
                </div>
            </div>
        </div>
    )
}